/* unplugin-vue-components disabled */import { render } from "./GroupColumnarChart.vue?vue&type=template&id=88e00d90&scoped=true"
import script from "./GroupColumnarChart.vue?vue&type=script&lang=js"
export * from "./GroupColumnarChart.vue?vue&type=script&lang=js"

import "./GroupColumnarChart.vue?vue&type=style&index=0&id=88e00d90&scoped=true&lang=less"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e00d90"]])

export default __exports__